export const selectHttpInfo = (state, requestName) => state.ui.http[requestName];
export const selectHttpIsFetching = (state, requestName) => selectHttpInfo(state, requestName).isFetching;
export const selectHttpIsError = (state, requestName) => selectHttpInfo(state, requestName).isError;
